import React from 'react';
import { FD120, FD125 } from '../../../services/d202Api';

interface AbnormalTabProps {
  formData: Partial<FD120>;
  abnormals: Partial<FD125>[];
  isEditing: boolean;
  getField: (key: keyof FD120) => FD120[keyof FD120];
  setField: (key: keyof FD120, value: FD120[keyof FD120]) => void;
}

/** Page3: 異常說明 tab */
const D202AbnormalTab: React.FC<AbnormalTabProps> = ({
  formData, abnormals, isEditing, getField, setField,
}) => {
  return (
    <div style={{ padding: '8px 0' }}>
      <div className="textarea-group">
        <label>異常說明 (主管)</label>
        <textarea
          value={String(formData.fd120_41 || '')}
          disabled
          readOnly
          rows={6}
          style={{ minHeight: 120 }} data-contract-field="fd120_41"
        />
      </div>

      {/* FD125 異常說明明細 Grid */}
      <div style={{ marginTop: 16 }}>
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th style={{ width: 41 }} data-contract-field="fd125_02">項數</th>
                <th style={{ width: 101 }} data-contract-field="fd125_11">異常說明代號</th>
                <th style={{ width: 276 }} data-contract-field="fd125_12">異常說明</th>
                <th style={{ width: 102 }} data-contract-field="fd125_13">預計作業日期</th>
                <th style={{ width: 110 }} data-contract-field="fd125_14">單據號碼</th>
              </tr>
            </thead>
            <tbody>
              {abnormals.length === 0 ? (
                <tr>
                  <td colSpan={5} style={{ textAlign: 'center', color: '#999' }}>
                    無異常說明明細
                  </td>
                </tr>
              ) : abnormals.map((row, i) => (
                <tr key={i}>
                  <td>{row.fd125_02 ?? i + 1}</td>
                  <td>{row.fd125_11 || ''}</td>
                  <td>{row.fd125_12 || ''}</td>
                  <td>{row.fd125_13 || ''}</td>
                  <td>{row.fd125_14 || ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default React.memo(D202AbnormalTab);
